import(/* webpackMode: "eager" */ "/codebuild/output/src192025171/src/monietab-web/src/app/contact/page.jsx");
